import React, { useEffect } from 'react';
import { useState } from 'react'
import { battery_faulty, battery_normal, grid_faulty, grid_normal, pv_faulty, pv_normal, triangle } from '../../Images/Icons';
import 'react-spring-bottom-sheet/dist/style.css';
import plants from './plants.json';
import { NavLink } from 'react-router-dom';
import { GetAlarmList, GetDataStation } from '../../Services/HomeServices';
import css from './HomePage.module.scss';

const PlantManagement = ({onCheckChange, onSelectPlant, onChangePlant, status}) => {
    const [state, setNewState] = useState({ showPoup: false, station: '' });


    const station_get = localStorage.getItem("station_get");
    const station2 = JSON.parse(localStorage.getItem('station'));
    const data_user = station2.filter(stat => stat.station_code === atob(station_get));
    const [selectedPlant, setSelectedPlant] = useState(data_user[0].station_code);
    
    useEffect(() => {
        setState({ station: JSON.parse(localStorage.getItem('station')) });
    }, []);

    const handleSearch = (event) => {
        const keyword = event.target.value.toLowerCase();
        const filterStation = station.filter(item => item.station_name.toLowerCase().includes(keyword) || item.station_address.toLowerCase().includes(keyword));
        setNewState({ ...state, station: filterStation });
        if(keyword === '') {
            setNewState({ ...state, station: JSON.parse(localStorage.getItem('station')) });
        }
    }
  
    const changeDataPlan = () => {
        
        localStorage.setItem("station_get", btoa(selectedPlant));
        onChangePlant();
        window.location.reload();
    };

    const handlePlantSelection = (plantId) => {
        console.log(station)
        
      setSelectedPlant(plantId);
    };
    const [alarmSum, setAlarmSum] = useState(null);

    
    async function GetDataAll() {

        try {
            const resultStation = await GetAlarmList();
            setAlarmSum(resultStation.data.return.lev); 
            
        } catch (error) {
          console.error('Error fetching dataStation:', error);
        }
    }
    useEffect(() => {GetDataAll()}, []);

    const setState = data => {
        setNewState(prevState => ({ ...prevState, ...data }));
    }

    const showPopupAlarm = () => {
        setState({ showPoup: true });
        setTimeout(() => {
            setState({ showPoup: false });
        }, 3000);
    }

    const renderDonut = (critical, major, minor, warning) => {
        const total = critical + major + minor + warning;
        const criticalDeg = (360 * (critical / total));
        const majorDeg = (360 * (major / total));
        const minorDeg = (360 * (minor / total));
        const warningDeg = (360 * (warning / total));


        return (<div style={{ width: 100, height: 100, position: "relative", border: 'solid 0px #dedede', borderRadius: '50%' }}>
            {/* { Critical } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: 'rotate(0deg)' }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#F62C42', transform: `rotate(${criticalDeg}deg)` }}></div>
            </div>
            {/* { Major } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: `rotate(${criticalDeg}deg)` }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#FF8438', transform: `rotate(${majorDeg}deg)` }}></div>
            </div>
            {/* { Minor } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: `rotate(${(criticalDeg + majorDeg)}deg)` }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#FDD020', transform: `rotate(${minorDeg}deg)` }}></div>
            </div>
            {/* { Warning } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: `rotate(${(criticalDeg + majorDeg + minorDeg)}deg)` }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#69aff4', transform: `rotate(${warningDeg}deg)` }}></div>
            </div>
            <div style={{
                width: 80, height: 80, position: 'absolute', background: '#F2F5FA', top: 0, right: 0, bottom: 0, left: 0, borderRadius: '50%', margin: 'auto',
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: 10, fontWeight: 400, color: '#79808F'
            }}>
                <div style={{ fontSize: 18, fontWeight: 500, color: '#292929' }}>{total}</div>
                Total Alarms
            </div>
        </div>);
    }

    const {showPoup, station} = state;

    if(alarmSum === null) return 'loading...';
    return (
        <div style={{ margin: 20, width: '100%', height:'70vh' }}>
            {status == 'Trouble' && 
                <div style={{ height: 'auto', marginRight: 40, marginTop: 30, padding: 10, border: 'solid 0px', background:'#FFFAE8', textAlign:'center', borderRadius:'12px', fontSize:'12px' }}>
                    ⚠️<br/>
                    We've detected an alarm at your plant.<br/> For help, contact our professional team at  <br/><u style={{fontWeight:'bold'}}><a href="mailto:maintenance.energy@modena.com">maintenance.energy@modena.com</a></u><br/>
                    We'll respond within 24 hours.
                </div> 
            }
            
            <div style={{ height: 320, marginRight: 40, marginTop: 30, padding: 0, border: 'solid 0px', }}>
                <div style={{
                    height: 36, borderRadius: 18,
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#F1F1F1', padding: '6px 16px'
                }}>
                    <input type="text" name="search-plant" placeholder='Enter Plant Name' onChange={handleSearch}
                        style={{ flex: 1, outline: 'none', border: 'none', marginRight: 10, background: '#F1F1F1', fontSize: 14 }} />
                    <span className='fi fi-rr-search' style={{ marginTop: 6 }}></span>
                </div>
                <div style={{ height: 320, overflowY: 'scroll', marginTop: 20 }}>
                {station.map((plant, i) => (
                    <div key={`plants-${i}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 10 }}>
                        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', width:'100%' }}>
                        <div style={{ width: 44, marginLeft: 4 }}>
                            <input className="form-check-input" type="radio" value={`${plant.id}`} name="plant" id={`check-${plant.id}`} style={{ borderColor: '#E0E3E9' }} checked={selectedPlant === `${plant.station_code}`} onChange={() => handlePlantSelection(`${plant.id}`)} />
                        </div>
                        <div onClick={() => handlePlantSelection(`${plant.station_code}`)} style={{width:'85%'}}>
                            <div style={{ fontSize: 14, fontWeight: 500, color: '#393D45', display: 'flex', justifyContent: 'space-between' }}>
                            <span>{plant.station_name}</span>
                            <div style={{
                                width: 50, height: 20, background: plant.status === 'offline' ? '#FFEFEC' : '#E5F6E5',
                                color: plant.status === 'offline' ? '#FF1D19' : '#3B9D3F', borderRadius: 8, display: 'flex', justifyContent: 'center',
                                alignItems: 'center', fontSize: 10, fontWeight: 700
                            }}>{plant.status === 'offline' ? 'Faulty' : 'Normal'}</div>
                            </div>
                            <div style={{ fontSize: 12, fontWeight: 400, color: '#8F8F8F' }}>{plant.station_address}</div>
                            {/* <div style={{ display: 'flex', alignItems: 'center', fontSize: 10, fontWeight: 500, marginTop: 6, marginBottom: 6, color: plant.status === 'Faulty' ? '#FF1D19' : '#8F8F8F' }}>
                            <img src={plant.status === 'Faulty' ? pv_faulty : pv_normal} alt="" style={{ marginRight: 4 }} />
                            <span>PV</span>
                            <img src={plant.status === 'Faulty' ? grid_faulty : grid_normal} alt="" style={{ marginLeft: 10, marginRight: 4 }} />
                            <span>GRID</span>
                            <img src={plant.status === 'Faulty' ? battery_faulty : battery_normal} alt="" style={{ marginLeft: 10, marginRight: 4 }} />
                            <span>BATTERY</span>
                            </div> */}
                        </div>
                        </div>
                        {plants.length - 1 !== i && <div style={{ height: 1, width: '100%', background: '#dedede', marginTop: 12, marginBottom: 12 }}></div>}
                    </div>
                ))}
                </div>
                <div onClick={changeDataPlan} style={{
                    height: 44, marginTop: 20, borderRadius: 8, background: '#2DFBB5', display: 'flex', justifyContent: 'center', alignItems: 'center',
                    fontSize: 16, fontWeight: 700, color: '#292929', cursor: 'pointer'
                }}>
                    Change Plant
                </div>
            </div>
        </div>
    )
}

export default PlantManagement